import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import {
  SystemCassandraForm,
  mountForm,
  unmountForm,
  showToast,
} from '@kineticdata/react';
import { generateFormButtons, FormError } from '@kineticdata/ui';
import { regSaga, regRoute } from '../../store';
import { Map } from 'immutable';
import { restartResourcesToastDefinition } from './SystemSetupTrustedCertificatesNew';
import { reload } from '../common/NoticesDropdown';

const formKey = 'system-setup-cassandra';

regRoute('SYSTEM_CASSANDRA_PAGE', '/system/setup/infra/cassandra');

regSaga(
  takeEvery('ENTER_SYSTEM_CASSANDRA_PAGE', function* () {
    yield call(mountForm, formKey);
  }),
);
regSaga(
  takeEvery('LEAVE_SYSTEM_CASSANDRA_PAGE', function* () {
    yield call(unmountForm, formKey);
  }),
);

const handleSave = () => () => {
  unmountForm(formKey);
  mountForm(formKey);
  showToast(restartResourcesToastDefinition);
  reload();
};

const FormLayout = ({ fields, error, buttons, bindings: { values } }) => (
  <form>
    <div className="heading heading-sm">
      <h2 className="h3">Cassandra Settings</h2>
    </div>
    <div className="row">
      <div className="col-6">{fields.get('property_datacenter')}</div>
      <div className="col-6">{fields.get('property_hosts')}</div>
      <div className="col-6">{fields.get('property_username')}</div>
      <div className="col-6">
        <div className="form-group--toggle">
          {fields.get('property_password')}
          {fields.get('changeProperty_password')}
        </div>
      </div>
      <div className="col-6">{fields.get('property_sslEnabled')}</div>
    </div>
    <div className="form-group--toggle">
      {!values.get('changeProperty_rootPem')
        ? fields.get('property_rootPem')
        : fields.get('property_new_rootPem')}
      {fields.get('changeProperty_rootPem')}
    </div>
    <div className="form-group--toggle">
      {!values.get('changeProperty_clientPem')
        ? fields.get('property_clientPem')
        : fields.get('property_new_clientPem')}
      {fields.get('changeProperty_clientPem')}
    </div>
    {error}
    <div className="form-buttons">{buttons}</div>
  </form>
);

export const SystemSetupCassandra = () => {
  return (
    <div className="content-container">
      <SystemCassandraForm
        formKey={formKey}
        onSave={handleSave}
        components={{
          FormError,
          FormButtons: generateFormButtons({
            submitLabel: 'Update Cassandra Settings',
            cancelPath: '/system/setup/config',
          }),
          FormLayout,
        }}
        alterFields={() =>
          ({ certificateFields }) =>
            certificateFields &&
            certificateFields
              .reduce(
                (reduction, name) =>
                  reduction.set(`property_${name}`, {
                    renderAttributes: {
                      filename: `cassandra_${name}.pem`,
                    },
                  }),
                Map(),
              )
              .toObject()
          }
      >
        {({ form }) => form}
      </SystemCassandraForm>
    </div>
  );
};
